import React from "react";
import Skeleton from "./Skeleton";

function SkeletonBalancePanel() {
  return (
    <div className="v1-panel">
      <div className="v1-balance-row">
        <div>
          <Skeleton width={72} height={12} />
          <Skeleton width={150} height={38} borderRadius="var(--radius-sm)" className="sk-balance-amount" />
        </div>
        <Skeleton width={68} height={24} borderRadius="999px" />
      </div>
      <Skeleton height={44} borderRadius="var(--radius-md)" className="sk-address-row" />
    </div>
  );
}

export default SkeletonBalancePanel;
